<template>
    <div class="container">
        <NavItem></NavItem>
        <Banner>
            <p slot="title">大闸蟹</p>
            <p slot="s-title">HAIRY CRABS</p>
        </Banner>
        <div class="d-container" v-if="!userAgent">
            <div class="d-nav">
                <a @click="handBack">大闸蟹</a>
                <span>></span>      
                <span class="taocan">{{title}}</span>             
            </div>
            <div class="d-content">
                <!-- 图片展示 -->
                <div class="d-left">
                    <img :src="showImgUrl" alt="">
                    <!-- 小图展示 -->
                    <el-carousel :interval="4000" type="card" height="200px">
                        <el-carousel-item v-for="(item,index) in imgUrl" :key="index">
                            <img @click="imgShow(index)" width="100%" :src="item" alt="">
                        </el-carousel-item>
                    </el-carousel>

                </div>
                <!-- 套餐 -->
                <div class="right">
                    <div class="title">
                        <p>{{title}}</p>
                        <p>{{data.detaildescribe}}</p>
                    </div>
                    <div class="zhekou">
                         <p class="tit">
                             <span>官方折后价：<span>￥{{data.price}} </span>元/张</span>                             
                             <span>统一零售价：￥{{data.retailprice}}元/张</span>
                             <span>量大从优</span>
                         </p>
                         <div>
                             <div v-for="(item,index) of detailiconimages" :key="index">
                                 <img :src="item.iconimage" alt="">
                                 <p>{{item.name}}</p>
                             </div>                          
                         </div>
                    </div>
                    <div class="step">
                        <div class="step-address">
                            <div class="left">
                                <img src="@/assets/images/jingxuan.png" alt="">
                            </div>
                            <div class="m-center">
                                <p class="m-title">觅蟹台承诺</p>
                                <p class="s-title">所售大闸蟹均由{{data.province}}产地直供</p>
                                <p class="x-title">只只佩戴防伪指环</p>
                            </div>
                            <div class="right">
                                <p>产品：<span>{{data.product}}</span></p>
                                <p>产区：<span>{{data.province}}</span></p>
                                <p>包装：<span>{{data.packing}}</span></p>
                            </div>
                        </div>
                        <div class="step-list">
                            <p>配套：<span>{{data.matching}}</span></p>
                            <p>净重：<span>{{data.weight}}</span></p>
                            <p>规格：<span>{{data.spec}}</span></p>
                        </div>  
                    </div>
                </div>
            </div>
        </div> 

        <div class="d-container1" v-else>
            <div class="d-nav1">
                <a @click="handBack">大闸蟹</a>
                <span>></span>      
                <span class="taocan">{{title}}</span>
            </div>
            <div class="d-content1">
                <!-- 图片展示 -->
                <div class="d-left">
                    <img :src="showImgUrl" alt="">
                    <!-- 小图展示 -->
                    <el-carousel :interval="4000" type="card" height="200px">
                        <el-carousel-item v-for="(item,index) in imgUrl" :key="(item,index)">
                            <img @click="imgShow(index)" width="100%" :src="item" alt="">
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <!-- 套餐 -->
                <div class="right">
                    <div class="title">
                        <p>{{title}}礼券</p>
                        <p>{{data.detaildescribe}}</p>
                    </div>
                    <div class="zhekou">
                         <p class="tit">
                             <span>官方折后价：<span>￥{{data.price}} </span>元/张</span>                             
                             <span>统一零售价：￥{{data.retailprice}}元/张</span>
                         </p>
                         <div>
                             <div v-for="(item,index) of detailiconimages" :key="index">
                                 <img :src="item.iconimage" alt="">
                                 <p>{{item.name}}</p>
                             </div>                          
                         </div>
                    </div>
                    <div class="step">
                        <div class="step-address">
                            <div class="left">
                                <img src="@/assets/images/jingxuan.png" alt="">
                            </div>
                            <div class="m-center">
                                <p class="m-title">觅蟹台承诺</p>
                                <p class="s-title">所售大闸蟹均由{{data.province}}产地直供</p>
                                <p class="x-title">只只佩戴防伪指环</p>
                            </div>                            
                        </div>
                        <div class="product">
                                <p>产品：<span>{{data.product}}</span></p>
                                <p>产区：<span>{{data.province}}</span></p>
                                <p>包装：<span>{{data.packing}}</span></p>
                        </div>
                        <div class="step-list">
                            <p>配套：<span>{{data.matching}}</span></p>
                            <p>净重：<span>{{data.weight}}</span></p>
                            <p>规格：<span>{{data.spec}}</span></p>
                        </div>  
                    </div>
                </div>
            </div>
        </div> 

        <!-- 内容 -->
        <div class="shoppingInfo" v-html="data.mealcontent"></div>
        
    </div>
</template>
<script>
export default {
    name:"xieDetail",
    data(){
        return{
            data:"",
            showImgUrl:"",
            imgUrl:[],
            detailiconimages:"",
            activeClass:"",
            title:""
        }
    },
    mounted(){
        var id=this.$route.query.id
        this.title=this.$route.query.title
        this.activeClass=this.$route.query.activeClass
        this.$http.get('api/index/crabmealdetail?id='+id).then(res=>{
            this.data=res.data.data
            this.imgUrl=this.data.detailimages
            this.detailiconimages=this.data.detailiconimages
            this.showImgUrl=this.imgUrl[0]
        })
    },
    methods:{
        handBack(){
            this.$router.back()
        },
        imgShow(index){
             this.showImgUrl=this.imgUrl[index]
        }
    }
}
</script>
<style scoped lang='scss'>
    .container{
        width: 100%;
        height: 100%;
        background: #fff;
    }
    .d-container{
        width: 80%;
        margin: 0 auto;
        padding-bottom: 10%;
        .d-nav{
            width: 100%;
            padding: 3% 0 1%;
            color: #333333;
            font-size: 18px;
            font-weight: bold;
            font-family: 思源黑体 CN Medium;
            a{
                font-size: 18px;
                margin-right: 1%;
                cursor: pointer;
            }
            .taocan{
                font-family:Helvetica;
                color:rgba(151,31,46,1);
                margin-left: 1%;
            }
        }
        .d-content{
            width: 100%;
            display: flex;
            .d-left{
                width: 35%;
                height: 420px;
                >img{
                    width: 100%;
                    height: 100%;
                }
            }
            .right{
                margin-left: 1%;
                border-left: 1px solid #F1EFF0;
                padding: 1%;
                width: 45%;
                .title,.zhekou{
                    padding: 2% 0;
                    font-size: 14px;
                    border-bottom: 1px dashed #F1EFF0;
                    color: #353235;
                    font-weight: bold;
                }
                .title p:nth-child(1){
                    color: #C21B31;
                    font-size:20px;
                    margin-bottom: 1%;
                }
                .zhekou {
                    padding: 4% 0;
                  .tit{
                    color: #949194;
                    span:nth-child(1){
                        span{
                            color: #C21B31;
                            font-size: 18px;
                        }
                    }
                    span:nth-child(2){
                        color: #B1AFB2;
                        font-size: 12px;
                        margin-left: 1%;
                    }
                    span:nth-child(3){
                        font-size: 16px;
                        background: #C21B31;
                        width: 70px;
                        color: white;
                        margin-left: 2%;
                        font-weight: normal;
                        display: inline-block;
                        position: relative;
                        padding: 0 1%;
                    }
                    span:nth-child(3)::after{
                        content:"";
                        display: block;
                        width: 0;height: 0;
                        border: 8px solid transparent;
                        border-right-color:  #C21B31;
                        position: absolute;
                        top:50%;
                        left:-16px;
                        transform: translateY(-50%)
                    }
                   }
                   >div{
                        margin-top: 2%;
                        max-width: 1110px;
                        background:#F7F5F6 ;
                        justify-content: space-around;
                        display: flex;
                        text-align: center;
                        font-size: 16px;
                        >div{
                            width:20%;
                            padding: 2% 0;
                        }
                        img{
                            width:60%;
                            margin-bottom: 8%;
                        }
                        p{
                            font-size: 14px;
                            font-weight: bold;
                        }
                   }
                }
                .step{
                    font-size: 16px;
                    width: 100%;
                    margin-top: 2%;
                    .step-address{
                        display: flex;
                        .left{
                            width: 15%;
                            height: 1.5rem;
                            border-right: 1px solid #eee;
                            text-align: center;
                            padding: 3% 0;
                            img{
                                width: 50%;
                                height: 100%;                              
                            }
                        }
                        .m-center{
                            line-height: 26px;
                            font-weight: bold;
                            width: 40%;
                            margin-left: 2%;
                            .s-title{
                                color: #695333;
                                margin: 1% 0;
                            }
                            .x-title{
                                font-weight: normal;
                            }
                        }
                        .right{
                            width: 40%;
                            margin-left: 2%;
                            padding-left: 2%;
                            p{
                                border-top: 1px solid #eee;
                                padding: 2% 0;
                                span{
                                    font-weight: bold;
                                }
                            }
                            p:last-child{
                                border-bottom: 1px solid #eee;
                            }
                        }
                    }
                    .step-list{
                        margin-top: 3%;
                        width: 100%;
                        p{
                            padding: 1% 0;
                            border-top: 1px solid #eee;
                            
                            span{
                                font-weight: bold;
                            }
                        }
                        p:last-child{
                                border-bottom: 1px solid #eee;
                        }
                    }
                }
                

            }          
        }
    }
    /* 移动端 */  
    .d-container1{
        width: 90%;
        margin: 0 auto;
    .d-nav1{
            width: 100%;
            padding: 7% 0;
            color: #333333;
            font-size: 13px;
            font-weight: bold;
            font-family: 思源黑体 CN Medium;
                a{
                    font-size: 13px;
                    margin-right: 1%;
                }
                .taocan{
                    font-family:Helvetica;
                    color:rgba(151,31,46,1);
                    margin-left: 1%;
                }
       }
    .title1{
        padding: 5%;
        width: 100%;
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        border-bottom: 1px solid #eee;
        }
    .d-content1{
           width: 100%;
            .d-left{
                width: 100%;
                margin: 0 auto;
                text-align: center;
                >img{
                    width: 80%;
                    height: 170px;
                }
            }
            .right{
                margin-left: 1%;
                padding: 1%;
                width: 100%;
                .title,.zhekou{
                    padding: 3% 0;
                    font-size: 14px;
                    border-bottom: 1px dashed #F1EFF0;
                    color: #353235;
                    font-weight: bold;
                }
                .title p:nth-child(1){
                    color: #C21B31;
                    font-size:20px;
                    margin: 3% 0;
                }
                .zhekou {
                    padding: 3% 0;
                  .tit{
                    color: #949194;
                    span:nth-child(1){
                        span{
                            color: #C21B31;
                            font-size: 18px;
                        }
                    }
                    span:nth-child(2){
                        color: #B1AFB2;
                        font-size: 12px;
                        margin: 3% 0;
                        display: block;
                    }
                   }
                   >div{
                       margin-top: 2%;
                        
                        background:#F7F5F6 ;
                        justify-content: space-around;
                        display: flex;
                        text-align: center;
                        font-size: 16px;
                        >div{
                            width: 25%;
                            padding: 2% 0;
                        }
                        img{
                            width:70%;
                            margin-bottom: 8%;
                        }
                        p{
                            font-size: 14px;
                            font-weight: bold;
                        }
                   }
                }
                .step{
                    font-size: 14px;
                    width: 100%;
                    margin-top: 2%;
                    .step-address{
                        display: flex;
                        margin-bottom: 3%;
                        .left{
                            width: 15%;
                            border-right: 1px solid #eee;
                            text-align: center;
                            padding: 3% 0;
                            img{
                                width: 80%;
                                height: 80%;                              
                            }
                        }
                        .m-center{
                            line-height: 20px;
                            font-weight: bold;
                            width: 80%;
                            margin-left: 2%;
                            .s-title{
                                color: #695333;
                                margin: 1% 0;
                            }
                            .x-title{
                                font-weight: normal;
                            }
                        }
                        
                    }
                    .product{
                            width: 100%;
                            p{
                                border-top: 1px solid #eee;
                                padding: 2% 0;
                                span{
                                    font-weight: bold;
                                }
                            }
                            p:last-child{
                                border-bottom: 1px solid #eee;
                            }
                    }
                    .step-list{
                        margin-top: 5%;
                        width: 100%;
                        p{
                            padding: 2% 0;
                            border-top: 1px solid #eee;
                            line-height: 18px;
                            span{
                                font-weight: bold;
                            }
                        }
                        p:last-child{
                                border-bottom: 1px solid #eee;
                        }
                    }
                }

            }     
        }
    }


</style>
<style>
.shoppingInfo  img{
    width: 100% !important;
}
.d-content .el-carousel__container{
    height: 100px !important;
    width: 100%;
    text-align: center;
}
.d-content .el-carousel__item img,.d-content1 .el-carousel__item img{
    width:60% !important;
}
.d-content .el-carousel__item img{
    height: 3rem;
}
.d-content1 .el-carousel__container{
    height: 80px !important;
}
.el-carousel__mask{
    width: 0;
}
.d-content1 .el-carousel__indicator--horizontal{
    padding: 1px !important;
    
}
.d-content1 .el-carousel__indicators--outside {
    margin-top: -5% !important;
    overflow: hidden;
    width: 100%;
}
.d-content1 .el-carousel__item img{
    height: 2rem;
}
</style>